import { render } from "./spaceModeItem.vue?vue&type=template&id=711edccd&scoped=true&ts=true"
import script from "./spaceModeItem.vue?vue&type=script&lang=ts"
export * from "./spaceModeItem.vue?vue&type=script&lang=ts"

import "./spaceModeItem.vue?vue&type=style&index=0&id=711edccd&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711edccd"]])

export default __exports__